import { __decorate, __metadata, __param } from "tslib";
import { Inject, Injectable } from 'angular-ts-decorators';
var ReleaseNotesService = (function () {
    function ReleaseNotesService($http) {
        this.$http = $http;
    }
    ReleaseNotesService.prototype.get = function (path, marketLocale, top) {
        if (top === void 0) { top = 3; }
        return this.$http
            .get("/support/api/releaseNotes?path=" + path + "&marketLocale=" + marketLocale + "&top=" + top)
            .then(function (response) { return response.data || []; });
    };
    ReleaseNotesService.$inject = ['$http'];
    ReleaseNotesService = __decorate([
        Injectable('releaseNotes'),
        __param(0, Inject('$http')),
        __metadata("design:paramtypes", [Function])
    ], ReleaseNotesService);
    return ReleaseNotesService;
}());
export { ReleaseNotesService };
